/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import store from "./store/store"
import { BSpinner } from 'bootstrap-vue'
import { SpinnerPlugin } from 'bootstrap-vue'
import './registerServiceWorker'
import VueCookies from "vue-cookies";  // npm install vue-cookies

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

//콤포넌트간의 데이터 주고 받기 위한 eventBus등록
export const eventBus = new Vue();
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(SpinnerPlugin)
//쿠키를 사용한다.
Vue.use(VueCookies);
//쿠키의 만료일은 1일이다. (글로벌 세팅)
Vue.$cookies.config("1d");

Vue.use(VueSweetalert2);
Vue.component('b-spinner', BSpinner)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
